import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { useEffect, useState } from "react";

const useCRMForm = () => {
  const Settings = useSettingsContext();

  const [autolectures, setAutolectures] = useState(false);

  const updateAutoreads = () => {
    const autoreads = Settings?.features.contactAutoReads;
    const should_filter_reads = location.search.includes("autolectures=true");
    if(autoreads) {
      if(should_filter_reads) {
        setAutolectures(true);
      } else {
        setAutolectures(false);
      }
    }
  }

  useEffect(() => {
    updateAutoreads()
    // eslint-disable-next-line
  }, [location.search]);

  return { autolectures }
}

export default useCRMForm;